export default __webpack_public_path__ + "static/media/loading.803f2436.gif";